module.exports = __webpack_public_path__ + "img/back-icon.ff16e66f.svg";